import { render, staticRenderFns } from "./SentenceMeaning.vue?vue&type=template&id=10113a86&scoped=true&"
import script from "./SentenceMeaning.vue?vue&type=script&lang=js&"
export * from "./SentenceMeaning.vue?vue&type=script&lang=js&"
import style0 from "./SentenceMeaning.vue?vue&type=style&index=0&id=10113a86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10113a86",
  null
  
)

export default component.exports